
import makerjs from "makerjs";
function B07(model,zoom,Param,fixedParam){
  //w,h,w1,w2
  console.log("Param==",Param[0].param);
  console.log("Param==",Param[1].param);
  console.log("Param==",Param);
    var plate=model.plate,markers=model.markers,myZoom=zoom*1,
    B = Param[0].param,R = Param[1].param, 
      //  plate = model.plate, markers = model.markers,
       markShift = fixedParam.markShift*1, markShiftTwo = fixedParam.markShiftTwo*1,
       markShiftThree = fixedParam.markShiftThree*1, markShiftFour = fixedParam.markShiftFour*1, markHolesOneD = fixedParam.markHolesOneD*1,

       b = B * 1 * myZoom,
       r = R * 1 * myZoom,
       // x0 = X*1*myZoom,
       // y0 = Y*1*myZoom;
       x0 = 0, x1 = b, x2 =b , y0 = 0, y1 = r, y2 =0,glassH = r, glassW = b,h=r,w=b;

   if (b !== 0) {
       var TxtB ="B="+ B;
   }  if (r !== 0) {
  var TxtR = "R="+R;
}



   var drawAbnormalShapeB07 = {
       paths: {
        "LeftLine": new makerjs.paths.Line([x0, y0], [x1, y1]),
        "TopLine":new makerjs.paths.Line([x1,y1], [x2,y2]), 
        "BottomLine": new makerjs.paths.Line([x2,y2], [x0, y0]),
       }
   };
   var drawAbnormalShapeB07MarkR = {
       paths: {
        "RightLine": new makerjs.paths.Line([x2+ markShift, y0], [x1+ markShift, y1]),
        "RightShortUpline": new makerjs.paths.Line([x1, y1], [x1+ 2 * markShift, y1]),
        "RightShortDnline": new makerjs.paths.Line([x2, y2], [x2+ 2 * markShift, y2]),
       }
   };
   var drawAbnormalShapeB07MarkB = {
       paths: {
        "BottomLine": new makerjs.paths.Line([x0, y0- markShift], [x2, y2- markShift]),
        "BotmShortLfline": new makerjs.paths.Line([x0, y0], [x0, y0 - 2 * markShift]),
        "BotmShortRTline": new makerjs.paths.Line([x2, y2], [x2, y2 - 2 * markShift]),
       }
  
   };
   makerjs.model.addCaption(drawAbnormalShapeB07MarkB, TxtB, [x0, y0 - 2 * markShift], [x2, y2 - 2 * markShift]);//长度文字
   makerjs.model.addCaption(drawAbnormalShapeB07MarkR, TxtR, [x2+2*markShift, y2], [x1+2*markShift, y1]);//宽度文字
   
  plate={
    models: {
      drawAbnormalShapeB07: drawAbnormalShapeB07,
      }
    };
    markers={
      models: {
        drawAbnormalShapeB07: drawAbnormalShapeB07,
        drawAbnormalShapeB07MarkR: drawAbnormalShapeB07MarkR,
        drawAbnormalShapeB07MarkB:drawAbnormalShapeB07MarkB,
        }
      };
    
   /*****************************************************************************/
   //return { plate, markers, glassW, glassH }
 
    return{w,h,plate, markers}  
};


export default B07;